import { render, staticRenderFns } from "./ConfirmAction.vue?vue&type=template&id=495c0a0e&scoped=true&"
import script from "./ConfirmAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmAction.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAction.vue?vue&type=style&index=0&id=495c0a0e&prod&lang=css&"
import style1 from "./ConfirmAction.vue?vue&type=style&index=1&id=495c0a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c0a0e",
  null
  
)

export default component.exports